<template>
  <form class="campaign-form" @submit.prevent="onSubmit">
    <div class="auth__body__main">
      <h2 class="auth__title">Create your account</h2>
      <p class="auth__desc">start your campaign in few minutes</p>
      <div class="auth__form">
        <div class="auth__form__block">
          <input required v-model="profile.login" type="text" class="input-default" placeholder="Login *">
        </div>
        <div class="auth__form__block">
          <input required v-model="profile.firstname" type="text" class="input-default" placeholder="First Name *">
        </div>
        <div class="auth__form__block">
          <input required v-model="profile.lastname" type="text" class="input-default" placeholder="Last Name *">
        </div>
        <div class="auth__form__block">
          <input required v-model="profile.skype_id" type="text" class="input-default" placeholder="Skype *">
        </div>
        <div class="auth__form__block">
          <input required v-model="profile.address_street" type="text" class="input-default" placeholder="Address *">
        </div>
        <div class="auth__form__block">
          <select required v-model="profile.address_country" class="input-default input-default--select2" style="color: #cbcfda; font-family: 'ProximaNova', sans-serif; font-weight: 600; font-size: 1.3rem;" @change="changeColor" id="country-select">
            <option value="0" disabled selected>Country *</option>
            <option value="af">Afghanistan</option>
            <option value="ax">Aland Islands</option>
            <option value="al">Albania</option>
            <option value="dz">Algeria</option>
            <option value="as">American Samoa</option>
            <option value="ad">Andorra</option>
            <option value="ao">Angola</option>
            <option value="ai">Anguilla</option>
            <option value="ag">Antigua and Barbuda</option>
            <option value="ar">Argentina</option>
            <option value="am">Armenia</option>
            <option value="aw">Aruba</option>
            <option value="au">Australia</option>
            <option value="at">Austria</option>
            <option value="az">Azerbaijan</option>
            <option value="bs">Bahamas</option>
            <option value="bh">Bahrain</option>
            <option value="bd">Bangladesh</option>
            <option value="bb">Barbados</option>
            <option value="by">Belarus</option>
            <option value="be">Belgium</option>
            <option value="bz">Belize</option>
            <option value="bj">Benin</option>
            <option value="bm">Bermuda</option>
            <option value="bt">Bhutan</option>
            <option value="bo">Bolivia</option>
            <option value="ba">Bosnia and Herzegovina</option>
            <option value="bw">Botswana</option>
            <option value="bv">Bouvet Island</option>
            <option value="br">Brazil</option>
            <option value="io">British Indian Ocean Territory</option>
            <option value="bn">Brunei Darussalam</option>
            <option value="bg">Bulgaria</option>
            <option value="bf">Burkina Faso</option>
            <option value="bi">Burundi</option>
            <option value="kh">Cambodia</option>
            <option value="cm">Cameroon</option>
            <option value="ca">Canada</option>
            <option value="cv">Cape Verde</option>
            <option value="ky">Cayman Islands</option>
            <option value="cf">Central African Republic</option>
            <option value="td">Chad</option>
            <option value="cl">Chile</option>
            <option value="cn">China</option>
            <option value="cx">Christmas Island</option>
            <option value="cc">Cocos (Keeling) Islands</option>
            <option value="co">Colombia</option>
            <option value="km">Comoros</option>
            <option value="cg">Congo</option>
            <option value="cd">Congo, The Democratic Republic of the</option>
            <option value="ck">Cook Islands</option>
            <option value="cr">Costa Rica</option>
            <option value="ci">Cote D'Ivoire</option>
            <option value="hr">Croatia</option>
            <option value="cu">Cuba</option>
            <option value="cw">Curacao</option>
            <option value="cy">Cyprus</option>
            <option value="cz">Czech Republic</option>
            <option value="dk">Denmark</option>
            <option value="dj">Djibouti</option>
            <option value="dm">Dominica</option>
            <option value="do">Dominican Republic</option>
            <option value="tp">East Timor</option>
            <option value="ec">Ecuador</option>
            <option value="eg">Egypt</option>
            <option value="sv">El Salvador</option>
            <option value="gq">Equatorial Guinea</option>
            <option value="er">Eritrea</option>
            <option value="ee">Estonia</option>
            <option value="et">Ethiopia</option>
            <option value="fk">Falkland Islands (Malvinas)</option>
            <option value="fo">Faroe Islands</option>
            <option value="fj">Fiji</option>
            <option value="fi">Finland</option>
            <option value="fr">France</option>
            <option value="fx">France, Metropolitan</option>
            <option value="gf">French Guiana</option>
            <option value="pf">French Polynesia</option>
            <option value="tf">French Southern Territories</option>
            <option value="ga">Gabon</option>
            <option value="gm">Gambia</option>
            <option value="ge">Georgia</option>
            <option value="de" selected="">Germany</option>
            <option value="gh">Ghana</option>
            <option value="gi">Gibraltar</option>
            <option value="gr">Greece</option>
            <option value="gl">Greenland</option>
            <option value="gd">Grenada</option>
            <option value="gp">Guadeloupe</option>
            <option value="gu">Guam</option>
            <option value="gt">Guatemala</option>
            <option value="gg">Guernsey</option>
            <option value="gn">Guinea</option>
            <option value="gw">Guinea-Bissau</option>
            <option value="gy">Guyana</option>
            <option value="ht">Haiti</option>
            <option value="hm">Heard Island and McDonald Islands</option>
            <option value="va">Holy See (Vatican City State)</option>
            <option value="hn">Honduras</option>
            <option value="hk">Hong Kong</option>
            <option value="hu">Hungary</option>
            <option value="is">Iceland</option>
            <option value="in">India</option>
            <option value="id">Indonesia</option>
            <option value="ir">Iran, Islamic Republic of</option>
            <option value="iq">Iraq</option>
            <option value="ie">Ireland</option>
            <option value="im">Isle of Man</option>
            <option value="il">Israel</option>
            <option value="it">Italy</option>
            <option value="jm">Jamaica</option>
            <option value="jp">Japan</option>
            <option value="je">Jersey</option>
            <option value="jo">Jordan</option>
            <option value="kz">Kazakstan</option>
            <option value="ke">Kenya</option>
            <option value="ki">Kiribati</option>
            <option value="kp">Korea, Democratic People's Republic of</option>
            <option value="kr">Korea, Republic of</option>
            <option value="kw">Kuwait</option>
            <option value="kg">Kyrgyzstan</option>
            <option value="la">Lao People's Democratic Republic</option>
            <option value="lo">Laos</option>
            <option value="lv">Latvia</option>
            <option value="lb">Lebanon</option>
            <option value="ls">Lesotho</option>
            <option value="lr">Liberia</option>
            <option value="ly">Libyan Arab Jamahiriya</option>
            <option value="li">Liechtenstein</option>
            <option value="lt">Lithuania</option>
            <option value="lu">Luxembourg</option>
            <option value="mo">Macau</option>
            <option value="mk">Macedonia</option>
            <option value="mg">Madagascar</option>
            <option value="mw">Malawi</option>
            <option value="my">Malaysia</option>
            <option value="mv">Maldives</option>
            <option value="ml">Mali</option>
            <option value="mt">Malta</option>
            <option value="mh">Marshall Islands</option>
            <option value="mq">Martinique</option>
            <option value="mr">Mauritania</option>
            <option value="mu">Mauritius</option>
            <option value="yt">Mayotte</option>
            <option value="mx">Mexico</option>
            <option value="fm">Micronesia, Federated States of</option>
            <option value="md">Moldova, Republic of</option>
            <option value="mc">Monaco</option>
            <option value="mn">Mongolia</option>
            <option value="me">Montenegro</option>
            <option value="ms">Montserrat</option>
            <option value="ma">Morocco</option>
            <option value="mz">Mozambique</option>
            <option value="mm">Myanmar</option>
            <option value="na">Namibia</option>
            <option value="nr">Nauru</option>
            <option value="np">Nepal</option>
            <option value="nl">Netherlands</option>
            <option value="an">Netherlands Antilles</option>
            <option value="nc">New Caledonia</option>
            <option value="nz">New Zealand</option>
            <option value="ni">Nicaragua</option>
            <option value="ne">Niger</option>
            <option value="ng">Nigeria</option>
            <option value="nu">Niue</option>
            <option value="nf">Norfolk Island</option>
            <option value="mp">Northern Mariana Islands</option>
            <option value="no">Norway</option>
            <option value="om">Oman</option>
            <option value="ap">Other Asia/Pacific</option>
            <option value="eu">Europe</option>
            <option value="pk">Pakistan</option>
            <option value="pw">Palau</option>
            <option value="ps">Palestinian Territory</option>
            <option value="pa">Panama</option>
            <option value="pg">Papua New Guinea</option>
            <option value="py">Paraguay</option>
            <option value="pe">Peru</option>
            <option value="ph">Philippines</option>
            <option value="pn">Pitcairn Islands</option>
            <option value="pl">Poland</option>
            <option value="pt">Portugal</option>
            <option value="pr">Puerto Rico</option>
            <option value="qa">Qatar</option>
            <option value="re">Reunion</option>
            <option value="ro">Romania</option>
            <option value="ru">Russian Federation</option>
            <option value="rw">Rwanda</option>
            <option value="sh">Saint Helena</option>
            <option value="kn">Saint Kitts and Nevis</option>
            <option value="lc">Saint Lucia</option>
            <option value="pm">Saint Pierre and Miquelon</option>
            <option value="vc">Saint Vincent and the Grenadines</option>
            <option value="ws">Samoa</option>
            <option value="sm">San Marino</option>
            <option value="st">Sao Tome and Principe</option>
            <option value="sa">Saudi Arabia</option>
            <option value="sn">Senegal</option>
            <option value="rs">Serbia</option>
            <option value="sc">Seychelles</option>
            <option value="sl">Sierra Leone</option>
            <option value="sg">Singapore</option>
            <option value="sk">Slovakia</option>
            <option value="si">Slovenia</option>
            <option value="sb">Solomon Islands</option>
            <option value="so">Somalia</option>
            <option value="za">South Africa</option>
            <option value="gs">South Georgia and the South Sandwich Islands</option>
            <option value="ss">South Sudan</option>
            <option value="es">Spain</option>
            <option value="lk">Sri Lanka</option>
            <option value="sd">Sudan</option>
            <option value="sr">Suriname</option>
            <option value="sj">Svalbard and Jan Mayen</option>
            <option value="sz">Swaziland</option>
            <option value="se">Sweden</option>
            <option value="ch">Switzerland</option>
            <option value="sy">Syrian Arab Republic</option>
            <option value="tw">Taiwan</option>
            <option value="tj">Tajikistan</option>
            <option value="tz">Tanzania, United Republic of</option>
            <option value="th">Thailand</option>
            <option value="tl">Timor-Leste</option>
            <option value="tg">Togo</option>
            <option value="tk">Tokelau</option>
            <option value="to">Tonga</option>
            <option value="tt">Trinidad and Tobago</option>
            <option value="tn">Tunisia</option>
            <option value="tr">Turkey</option>
            <option value="tm">Turkmenistan</option>
            <option value="tc">Turks and Caicos Islands</option>
            <option value="tv">Tuvalu</option>
            <option value="ug">Uganda</option>
            <option value="ua">Ukraine</option>
            <option value="ae">United Arab Emirates</option>
            <option value="gb">United Kingdom</option>
            <option value="us">United States</option>
            <option value="uy">Uruguay</option>
            <option value="uz">Uzbekistan</option>
            <option value="vu">Vanuatu</option>
            <option value="ve">Venezuela</option>
            <option value="vn">Vietnam</option>
            <option value="vg">Virgin Islands, British</option>
            <option value="vi">Virgin Islands, U.S.</option>
            <option value="wf">Wallis and Futuna</option>
            <option value="eh">Western Sahara</option>
            <option value="ye">Yemen</option>
            <option value="zm">Zambia</option>
            <option value="zw">Zimbabwe</option>
          </select>
        </div>
        <div class="auth__form__block">
          <input required v-model="profile.address_zip" type="text" class="input-default" placeholder="Zip code *">
        </div>
        <div class="auth__form__block">
          <input required v-model="profile.address_city" type="text" class="input-default" placeholder="City *">
        </div>
        <div class="auth__form__block auth__form__block--fullw">
          <input required v-model="profile.email" type="email" class="input-default" placeholder="Email Address *">
        </div>
        <div class="auth__form__block auth__form__block--fullw">
          <input required v-model="profile.phone" type="text" class="input-default" placeholder="Phone number *">
        </div>
        <div class="auth__form__block">
          <input required v-model="profile.password" type="password" class="input-default" placeholder="Password *">
        </div>
        <div class="auth__form__block">
          <input required v-model="profile.password_repeat" type="password" class="input-default"
                 placeholder="Confirm Password *">
        </div>
        <div class="auth__form__terms" style="margin-bottom: 20px">
          <label class="checkbox-default">
            <input type="checkbox" class="checkbox-default__input" v-model="CHK_TAC" name="privacyPolicy">
            <span class="checkbox-default__body">
                    <a href="/terms_of_service" target="_blank" style="color: inherit;">Terms & Conditions</a>
                  </span>
          </label>
          <label class="checkbox-default">
            <input type="checkbox" class="checkbox-default__input" v-model="CHK_PAP">
            <span class="checkbox-default__body">
                    <a href="/privacy_policy" target="_blank" style="color: inherit;">Privacy & Policy</a>
                  </span>
          </label>
        </div>
        <div class="auth__form__captcha">
          <!--<vue-recaptcha @verify="onVerify"-->
          <!--sitekey="6Ld_i2QUAAAAALWqR7gEk3ldPW6DHwE78ofcFvm2">-->
          <vue-recaptcha @verify="onVerify"
                         sitekey="6LeDIB0TAAAAAF3Q3f23DCpyDWTtJiGE5ZSuM1z2">
          </vue-recaptcha>
        </div>
      </div>
    </div>
    <div class="auth__body__controls">
      <button class="button button--primary" :disabled=" (CHK_TAC == false && CHK_PAP == false)"
              v-bind:class="{ disabled : (!CHK_TAC || !CHK_PAP) }">Create Account
      </button>
      <router-link class="button button--secondary-otln" to="/">Back to site</router-link>
    </div>
  </form>
</template>

<script>
import apiCall from '../../utils/api'
import axios from 'axios'
import Swal from 'sweetalert2'
import VueRecaptcha from 'vue-recaptcha'
import $ from 'jquery'

export default {
  name: 'Profile',
  components: {VueRecaptcha},
  data () {
    return {
      sitekey: '6LeDIB0TAAAAAF3Q3f23DCpyDWTtJiGE5ZSuM1z2',
      recaptchaVerified: false,
      CHK_TAC: true,
      CHK_PAP: true,
      profile: this.$parent.profile,
      action: this.$parent.action,
      form: {
        success: false,
        error: false
      }
    }
  },
  mounted: function () {
    if (this.action === 'Edit') {
      apiCall({controller: 'Account', method: 'GET'})
        .then(resp => {
          this.profile = resp.data.response[0]
        })
        .catch(err => {
          this.form.error = err
          console.log(err)
        })
    }
    let recaptcha = document.createElement('script')
    recaptcha.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit')
    document.head.appendChild(recaptcha)
  },
  methods: {
    changeColor: function () {
      $('#country-select').css('color', '#323B53')
    },
    saveProfile () {
      const {profile} = this
      profile.name = profile.firstname + ' ' + profile.lastname
      delete profile.firstname
      delete profile.lastname
      delete profile.adress
      profile.type = 'DIRECT'
      profile.read_only = false
      profile.status = 'NEW'

      if (this.action === 'Create') {
        axios.post('/api/signup', {profile})
          .then(function (response) {
            console.log(response)
            if (response.data.status === 'OK') {
              Swal('Success', 'You have been signed up successfully. Our customer representative will contact you with further instructions', 'success')
              setTimeout(function () { window.location = '/login' }, 3000)
            } else {
              let errText = response.data.message
              Swal('Warning', '<b>Errors:</b> <br />' + errText, 'warning')
            }
          })
      }
    },
    onSubmit: function () {
      console.log('captcha: ' + this.recaptchaVerified)
      if (!this.recaptchaVerified) {
        alert('ReCaptcha!')
        return true
      }
      this.saveProfile()
    },
    onVerify: function (response) {
      console.log('Verify: ' + response)
      this.recaptchaVerified = response
    },
    onExpired: function () {
      console.log('Expired')
    },
    resetRecaptcha () {
      this.$refs.recaptcha.reset()
    }
  }
}
</script>

<style>
  button.disabled {
    cursor: not-allowed;
  }

  .checkbox-default {
    border: none;
  }

  .checkbox-default__body {
    width: 135px;
  }
</style>



// WEBPACK FOOTER //
// src/components/account/advertiser.vue